@if (data?.infoOnly) {
  <div class="w-full px-6 py-7 text-center sm:px-8">
    <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-[#1B3777]">
      <svg class="h-7 w-7" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
        <path d="M12 11v5m0-8h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </div>
    <h2 class="mb-2 text-lg font-semibold leading-6 text-slate-900">
      {{ data?.titleKey | transloco }}
    </h2>
    <p class="mx-auto max-w-sm whitespace-pre-line text-sm leading-6 text-slate-600">
      {{ data?.translationKey | transloco }}
    </p>
    <div class="mt-6">
      <button class="w-full rounded-lg bg-[#1B3777] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#142a5c] focus:outline-none focus:ring-2 focus:ring-[#1B3777] focus:ring-offset-2 sm:w-auto sm:min-w-32"
        mat-dialog-close>
        OK
      </button>
    </div>
  </div>
} @else {
<div>
  @if(!data?.infoOnly && data?.org?.toLowerCase() != 'driveup'){
    <div class="flex justify-center py-4">
      <svg width="106" height="117" viewBox="0 0 106 117" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M74.0049 23.325L58.7525 11.805C55.3515 9.23619 50.6589 9.2362 47.2578 11.805L32.0055 23.325L13.8482 29.8366C9.49901 31.3963 6.89367 35.8495 7.6651 40.405L10.6508 58.0367L7.6651 75.6684C6.89366 80.2239 9.49902 84.6771 13.8482 86.2368L32.0055 92.7484L47.2578 104.268C50.6589 106.837 55.3515 106.837 58.7525 104.268L74.0049 92.7484L92.1622 86.2368C96.5114 84.6771 99.1167 80.2239 98.3453 75.6684L95.3595 58.0367L98.3453 40.405C99.1167 35.8495 96.5114 31.3963 92.1622 29.8366L74.0049 23.325Z"
          fill="#FFEDE3" stroke="#FFF5F5" stroke-width="13.6229" />
        <path
          d="M56.5059 53.5V54.5H60.0059C60.1385 54.5 60.2656 54.5527 60.3594 54.6464C60.4532 54.7402 60.5059 54.8674 60.5059 55C60.5059 55.1326 60.4532 55.2598 60.3594 55.3536C60.2656 55.4473 60.1385 55.5 60.0059 55.5H59.4679L58.6149 66.16C58.5746 66.6612 58.3471 67.1289 57.9776 67.4698C57.6081 67.8108 57.1237 68.0001 56.6209 68H50.3909C49.8881 68.0001 49.4037 67.8108 49.0341 67.4698C48.6646 67.1289 48.4371 66.6612 48.3969 66.16L47.5439 55.5H47.0059C46.8733 55.5 46.7461 55.4473 46.6523 55.3536C46.5585 55.2598 46.5059 55.1326 46.5059 55C46.5059 54.8674 46.5585 54.7402 46.6523 54.6464C46.7461 54.5527 46.8733 54.5 47.0059 54.5H50.5059V53.5C50.5059 53.1022 50.6639 52.7206 50.9452 52.4393C51.2265 52.158 51.608 52 52.0059 52H55.0059C55.4037 52 55.7852 52.158 56.0665 52.4393C56.3478 52.7206 56.5059 53.1022 56.5059 53.5ZM51.5059 53.5V54.5H55.5059V53.5C55.5059 53.3674 55.4532 53.2402 55.3594 53.1464C55.2656 53.0527 55.1385 53 55.0059 53H52.0059C51.8733 53 51.7461 53.0527 51.6523 53.1464C51.5585 53.2402 51.5059 53.3674 51.5059 53.5V53.5ZM50.0059 57.029L50.5059 65.529C50.5085 65.5954 50.5244 65.6607 50.5526 65.7209C50.5808 65.7811 50.6207 65.8351 50.6701 65.8797C50.7194 65.9244 50.7771 65.9587 50.8398 65.9807C50.9026 66.0027 50.9691 66.012 51.0355 66.008C51.1018 66.004 51.1668 65.9868 51.2264 65.9575C51.2861 65.9281 51.3393 65.8871 51.3829 65.8369C51.4265 65.7867 51.4597 65.7283 51.4804 65.6651C51.5012 65.602 51.5092 65.5353 51.5039 65.469L51.0039 56.969C51.0012 56.9026 50.9853 56.8373 50.9571 56.7771C50.9289 56.7169 50.889 56.6629 50.8397 56.6183C50.7904 56.5736 50.7326 56.5393 50.6699 56.5173C50.6071 56.4953 50.5406 56.486 50.4743 56.49C50.4079 56.494 50.343 56.5112 50.2833 56.5405C50.2237 56.5699 50.1705 56.6109 50.1268 56.6611C50.0832 56.7113 50.0501 56.7697 50.0293 56.8329C50.0085 56.896 50.0005 56.9627 50.0059 57.029V57.029ZM56.5359 56.501C56.4035 56.4934 56.2736 56.5386 56.1746 56.6267C56.0756 56.7148 56.0156 56.8387 56.0079 56.971L55.5079 65.471C55.5036 65.6014 55.5504 65.7282 55.6383 65.8246C55.7263 65.9209 55.8484 65.979 55.9786 65.9866C56.1088 65.9942 56.2368 65.9506 56.3353 65.8651C56.4338 65.7796 56.495 65.659 56.5059 65.529L57.0059 57.029C57.0135 56.8967 56.9683 56.7667 56.8802 56.6677C56.792 56.5687 56.6682 56.5087 56.5359 56.501V56.501ZM53.5059 56.5C53.3733 56.5 53.2461 56.5527 53.1523 56.6464C53.0585 56.7402 53.0059 56.8674 53.0059 57V65.5C53.0059 65.6326 53.0585 65.7598 53.1523 65.8536C53.2461 65.9473 53.3733 66 53.5059 66C53.6385 66 53.7656 65.9473 53.8594 65.8536C53.9532 65.7598 54.0059 65.6326 54.0059 65.5V57C54.0059 56.8674 53.9532 56.7402 53.8594 56.6464C53.7656 56.5527 53.6385 56.5 53.5059 56.5Z"
          fill="#DC0032" />
      </svg>
    </div>
  }

  @if (!data?.text) {
    <div class="px-6">
      <p class=" font-semibold text-black text-center">
        Är du säker på att du vill avboka din <br>
        parkering?
      </p>
      <p class="text-sm text-[#6C757D] text-center my-[10px]">
        Om du avbokar din plats blir den tillgänglig för <br>
        andra att boka.
      </p>
    </div>
  } @else {
    @if (data?.text) {
      <div class="px-6">
        <p [ngClass]="{'mt-4': data?.org?.toLowerCase() == 'driveup'}"
          class="text-sm text-[#6C757D] text-center my-[10px] whitespace-pre-line break-words max-w-md mx-auto leading-relaxed">
          {{ data?.text[locale] }}
        </p>
      </div>
    }
  }
  <div class="gap-4 flex justify-center mt-[10px] bg-[#F8F9FA] py-8 px-6">
    @if(data?.org?.toLowerCase() != 'ving' && data?.org?.toLowerCase() != 'driveup'){
      <button class="py-3 px-8 rounded-lg  font-medium text-sm leading-6 text-[#1B3777] border-2 border-[#1B3777]"
        mat-dialog-close>
        {{ 'HANDLE_BOOKING.CANCEL' | transloco }}
      </button>
      <button class="py-3 px-8 rounded-lg  font-medium text-sm leading-6 bg-[#DC0032] text-white"
        [mat-dialog-close]="true">
        {{ 'HANDLE_BOOKING.CONFIRM' | transloco }}
      </button>
    } @else{
      <button class="py-3 px-8 rounded-lg  font-medium text-sm leading-6 text-[#1B3777] border-2 border-[#1B3777]"
        mat-dialog-close>
        OK
      </button>
    }
  </div>
</div>
}